import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-open-in-browser",
  templateUrl: "./med-icon-open-in-browser.component.html",
})
export class MedIconOpenInBrowserComponent extends SvgMixinComponent {}
